module.exports = {
	"en": {}
};


//////////////////
// WEBPACK FOOTER
// ../public/messages/data.json
// module id = 479
// module chunks = 0